module.exports = __webpack_public_path__ + "static/img/view5-4.3446b2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view5-4.png
// module id = eIhJ
// module chunks = 1